import { ProfileView } from "@authory-packages/core";
import { getViewIcon } from "../../utils/getViewIcon";
import { getViewName } from "../../utils/getViewName";
import { DropdownOptionCTA } from "../DropdownOptionCTA";
import { SelectViewTypeWrapper } from "./SelectViewType.styles";

interface SelectViewTypeProps {
    activeView: ProfileView;
    onSelectView: (view: ProfileView) => void;
}

export const SelectViewType = ({ activeView, onSelectView }: SelectViewTypeProps) => {
    const Otps = ({ children }: React.PropsWithChildren) => <>{children}</>;

    return (
        <SelectViewTypeWrapper>
            <Otps>
                <DropdownOptionCTA
                    label={getViewName(ProfileView.TwoColumnThumbnail)}
                    icon={getViewIcon(ProfileView.TwoColumnThumbnail)}
                    onClick={() => onSelectView(ProfileView.TwoColumnThumbnail)}
                    active={activeView === ProfileView.TwoColumnThumbnail}
                />
            </Otps>
            <Otps>
                <DropdownOptionCTA
                    label={getViewName(ProfileView.Masonry)}
                    icon={getViewIcon(ProfileView.Masonry)}
                    onClick={() => onSelectView(ProfileView.Masonry)}
                    active={activeView === ProfileView.Masonry}
                />
            </Otps>
            <Otps>
                <DropdownOptionCTA
                    label={getViewName(ProfileView.OneColumnThumbnail)}
                    icon={getViewIcon(ProfileView.OneColumnThumbnail)}
                    onClick={() => onSelectView(ProfileView.OneColumnThumbnail)}
                    active={activeView === ProfileView.OneColumnThumbnail}
                />
            </Otps>
            <Otps>
                <DropdownOptionCTA
                    label={getViewName(ProfileView.List)}
                    icon={getViewIcon(ProfileView.List)}
                    onClick={() => onSelectView(ProfileView.List)}
                    active={activeView === ProfileView.List}
                />
            </Otps>
            <Otps>
                <DropdownOptionCTA
                    label={getViewName(ProfileView.Text)}
                    icon={getViewIcon(ProfileView.Text)}
                    onClick={() => onSelectView(ProfileView.Text)}
                    active={activeView === ProfileView.Text}
                />
            </Otps>
        </SelectViewTypeWrapper>
    );
};
